import { takeEvery } from "redux-saga/effects";

import { GET_DATA } from "actions/apiOperations.js";

import { getJSON } from "apis/apiHelpers.js";

import sharedApiSaga from "sagas/sharedApiSaga.js";

// Simple in-memory dedupe map for GET requests. Keys are derived from
// request path + serialized params. While a request for the same key is
// in-flight, subsequent GET_DATA actions for the same key will be ignored.
const inFlightGetRequests = new Set();

export default function* watchGetData() {
  yield takeEvery(GET_DATA, getData);
}

export const getData = function* ({ path, actions, params }) {
  // Helper to stringify params while stripping functions which cannot
  // be JSON.stringified and would collapse keys unintentionally.
  const safeStringify = (obj) => {
    try {
      return JSON.stringify(obj, function replacer(key, value) {
        if (typeof value === 'function') return '<fn>';
        return value;
      });
    } catch (e) {
      try {
        return String(obj);
      } catch (e2) {
        return '';
      }
    }
  };

  // Include action success type (if present) so requests with the same
  // path but different intended consumers are not deduped incorrectly.
  const actionType = actions && actions.success ? actions.success : safeStringify(actions);

  const key = `${path}::${actionType}::${params ? safeStringify(params) : ''}`;

  if (inFlightGetRequests.has(key)) {
    // Another identical request is already in-flight; skip duplicate.
    // eslint-disable-next-line no-console
    console.debug('Skipping duplicate GET_DATA for', key);
    return;
  }

  inFlightGetRequests.add(key);

  try {
    return yield* sharedApiSaga(getJSON, path, actions, params);
  } finally {
    inFlightGetRequests.delete(key);
  }
};
